// extracted by mini-css-extract-plugin
export default {"onlyDark":"Testimonials_onlyDark__862iE","onlyLight":"Testimonials_onlyLight__4XL7C","testimonials":"Testimonials_testimonials__vgqv1"};